
// pages/StockScreener.js
import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchMetrics } from '../api';
// ***STOCK SCREENER***
// import StockSearch from '../components/StockSearch';

// import MetricsFilter from '../components/MetricsFilter';


import ScreenerFilter from '../components/ScreenerFilter';

import InfoTooltip from '../components/InfoTooltip';
import { StockComparisonContext } from '../contexts/StockComparisonContext';
import { StockScreenerContext } from '../contexts/StockScreenerContext';
import definitions from '../constants/metricsDefinitions';
import './StockScreener.css';

import { METRIC_FIELDS } from "../constants/metricFields";


// ***STOCK SCREENER***
// Available stock symbols
// const AVAILABLE_STOCKS = ['AAPL', 'GOOGL', 'MSFT', 'AMZN', 'TSLA', 'NVDA', 'META', 'NFLX', 'CRM', 'ADBE'];

// All available metrics

const ALL_METRICS = METRIC_FIELDS
  .map(m => ({
    label: m.label,
    key: m.value
  }))
  .sort((a, b) => a.label.localeCompare(b.label));


export default function StockScreener() {
  const navigate = useNavigate();
  const filterRef = useRef(null);
  
  // Context state - ALL from StockScreenerContext including activeFilters
  const {
    screenedStocks,
    selectedForComparison,
    selectedMetrics,
    metricsData,
    activeFilters,
    // ***STOCK SCREENER***
    // addStock,
    removeStock,
    toggleSelection,
    clearSelection,
    setSelectedMetrics,
    setActiveFilters,
    updateMetricsData,
    // ***STOCK SCREENER***
    // isStockScreened
  } = useContext(StockScreenerContext);

  // Local state
  const [loading, setLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Get comparison context only for navigation
  const { setSelectedSymbols } = useContext(StockComparisonContext);

  // Fetch metrics for a stock when added to screener
  const fetchStockMetrics = useCallback(async (symbol) => {
    if (metricsData[symbol]) return; // Already have data
    
    setLoading(true);
    try {
      const data = await fetchMetrics(symbol);
      if (data) {
        updateMetricsData(symbol, data);
      }
    } catch (error) {
      console.error(`Error fetching metrics for ${symbol}:`, error);
    } finally {
      setLoading(false);
    }
  }, [metricsData, updateMetricsData]);

  // ***STOCK SCREENER***
  // Add stock to screener
  // const addToScreener = (symbol) => {
  //   if (!isStockScreened(symbol)) {
  //     addStock(symbol);
  //     fetchStockMetrics(symbol);
  //   }
  // };

  // Remove stock from screener
  const removeFromScreener = (symbol) => {
    removeStock(symbol);
  };

  // Handle filter changes - wrap in useCallback
  const handleFilterChange = useCallback((filters) => {
    setActiveFilters(filters);
  }, [setActiveFilters]);

  // Get filtered stocks based on active filters
  const getFilteredStocks = () => {
    if (!activeFilters || activeFilters.length === 0 || !Object.keys(metricsData).length) {
      return screenedStocks;
    }

    return screenedStocks.filter(symbol => {
      const stockData = metricsData[symbol];
      if (!stockData) return true; // Include stocks without data yet

      // Check if the stock passes all filters
    //   for (const filter of activeFilters) {
    //     const value = stockData[filter.metric];
        
    //     if (value === null || value === undefined) continue;
        
    //     switch (filter.operator) {
    //       case '>':
    //         if (!(value > filter.value)) return false;
    //         break;
    //       case '<':
    //         if (!(value < filter.value)) return false;
    //         break;
    //       case '=':
    //         if (!(value === filter.value)) return false;
    //         break;
    //       case '>=':
    //         if (!(value >= filter.value)) return false;
    //         break;
    //       case '<=':
    //         if (!(value <= filter.value)) return false;
    //         break;
    //       default:
    //         break;
    //     }
    //   }

         // Check if the stock passes all range filters
     for (const filter of activeFilters) {
       const value = stockData[filter.metric];
       
       if (value === null || value === undefined) continue;
       
       // Check if value is within the min/max range
       if (value < filter.min || value > filter.max) {
         return false;
       }
     }
      
      return true;
    });
  };

  // Toggle metric selection for table display
  const toggleMetric = (metric) => {
    const isSelected = selectedMetrics.some(m => m.key === metric.key);
    
    if (isSelected) {
      setSelectedMetrics(prev => prev.filter(m => m.key !== metric.key));
    } else {
      setSelectedMetrics(prev => [...prev, metric]);
    }
  };

  // Handle comparison
  const handleCompare = () => {
    if (selectedForComparison.length === 0) return;
    
    setSelectedSymbols(selectedForComparison);
    clearSelection();
    navigate('/comparison');
  };

  // Fetch metrics for existing stocks when component mounts
  useEffect(() => {
    screenedStocks.forEach(symbol => {
      if (!metricsData[symbol]) {
        fetchStockMetrics(symbol);
      }
    });
  }, [screenedStocks, metricsData, fetchStockMetrics]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isDropdownOpen && filterRef.current && !filterRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isDropdownOpen]);

  const filteredStocks = getFilteredStocks();

  return (
    <div className="stock-screener-page">
      <div className="main-container">
        <div className="content-area">
          <h2>Stock Screener - More stocks coming very soon! Bookmark and check back in 2 days - update 6 Dec 2025</h2>
          
          {/* Stock Search Component - ***STOCK SCREENER*** */}
          {/* <div className="search-section">
            <StockSearch 
              availableStocks={AVAILABLE_STOCKS}
              addToWatchlist={addToScreener}
              watchlistStocks={screenedStocks}
              placeholder="Search and add stocks to screen..."
            />
          </div> */}

          {/* Results Summary */}
          {screenedStocks.length > 0 && (
            <div className="results-summary">
              <p>
                Screening {screenedStocks.length} stocks 
                {activeFilters && activeFilters.length > 0 && 
                  `, ${filteredStocks.length} match your criteria`
                }
              </p>
            </div>
          )}

          {/* Screener Table */}
          {screenedStocks.length > 0 ? (
            <div className="table-container">
              <div className="screener-actions">
                <button 
                  className="compare-btn"
                  disabled={selectedForComparison.length === 0}
                  onClick={handleCompare}
                >
                  Compare Selected ({selectedForComparison.length})
                </button>
              </div>

              <div className="metrics-filter-container" ref={filterRef}>
                <button 
                  className="metrics-filter-button"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  Add/Remove Metrics
                </button>
                
                {isDropdownOpen && (
                  <div className="metrics-dropdown">
                    {ALL_METRICS.map(metric => (
                      <div key={metric.key} className="metric-option">
                        <label>
                          <input
                            type="checkbox"
                            checked={selectedMetrics.some(m => m.key === metric.key)}
                            onChange={() => toggleMetric(metric)}
                          />
                          {metric.label}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="table-scroll">
                <table className="screener-table">
                  <thead>
                    <tr>
                      <th className="select-column">Select</th>
                      <th className="stock-column">Stock</th>
                      {selectedMetrics.map(metric => (
                        <th key={metric.key} className="metric-column">
                          <div className="metric-header">
                            {metric.label}
                            <InfoTooltip text={definitions[metric.key] || "No description"} />
                          </div>
                        </th>
                      ))}
                      <th className="action-column">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredStocks.map(stock => (
                      <tr key={stock}>
                        <td className="select-cell">
                          <input
                            type="checkbox"
                            checked={selectedForComparison.includes(stock)}
                            onChange={() => toggleSelection(stock)}
                          />
                        </td>
                        <td className="stock-cell">{stock}</td>
                        {selectedMetrics.map(metric => (
                          <td key={`${stock}-${metric.key}`} className="metric-cell">
                            {loading && !metricsData[stock] ? (
                              <span className="loading-placeholder">Loading...</span>
                            ) : metricsData[stock] && metricsData[stock][metric.key] != null ? (
                              metricsData[stock][metric.key].toFixed(2)
                            ) : (
                              "NA"
                            )}
                          </td>
                        ))}
                        <td className="action-cell">
                          <button 
                            className="remove-button"
                            onClick={() => removeFromScreener(stock)}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {filteredStocks.length === 0 && activeFilters && activeFilters.length > 0 && (
                <div className="no-results">
                  <p>No stocks match your filter criteria. Try adjusting your filters.</p>
                </div>
              )}
            </div>
          ) : (
            <div className="empty-screener">
              <p>Add stocks above to start screening and filtering.</p>
            </div>
          )}
        </div>

        <div className="filter-sidebar">
          {/* <MetricsFilter 
            onFilterChange={handleFilterChange}
            activeFilters={activeFilters}
          /> */}

         <ScreenerFilter 
           onFilterChange={handleFilterChange}
           activeFilters={activeFilters}
           metricsData={metricsData}
         />

        </div>
      </div>
    </div>
  );
}